// <div data-controller="sidebar" data-action="keydown.esc@window->sidebar#close" data-collapsed>
//   <button data-action="click->sidebar#toggle">«</button><!-- desktop collapse -->
//   <button data-action="click->sidebar#open">☰</button>
//   <div data-sidebar-target="drawer" class="hidden">
//     <div data-action="click->sidebar#close"><!-- backdrop --></div>
//     <div><!-- panel -->
//       <button data-action="click->sidebar#close">✕</button>
//     </div>
//   </div>
// </div>
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['drawer']

  open() {
    this.drawerTarget.classList.remove('hidden')
  }

  close() {
    this.drawerTarget.classList.add('hidden')
  }

  // Desktop collapse; the cookie lets the layout render the same state server-side
  toggle() {
    const collapsed = this.element.toggleAttribute('data-collapsed')
    // path=/ so non-/admin pages using the admin layout (e.g. /user_search_terms) see it too
    document.cookie = `admin_sidebar=${collapsed ? 'collapsed' : 'expanded'}; path=/; max-age=31536000; samesite=lax`
    // Clear the old path=/admin cookie, which would otherwise shadow this one under /admin
    document.cookie = 'admin_sidebar=; path=/admin; max-age=0'
  }
}
